import SwitchOne from "../Components/Switch";
import AppImages from "./AppImages";
import AppColors from "./AppColors";
export const MasterSettingsData = [
  {
    id: 1,
    title: "Customer Profile & Logo",
    img: AppImages.profilePic,
    nav: "CompanyProfile",
  },
  {
    id: 2,
    title: "Integration Setting",
    img: AppImages.profileInte,
    nav: "IntegrationSet",
  },
  {
    id: 3,
    title: "Notification Setting",
    img: AppImages.profileNoti,
    nav: "NotiTopTab",
  },
  {
    id: 4,
    title: "Access Right",
    img: AppImages.profileRight,
    nav: "AcessRightone",
  },
];
export const MasterSettingsDataone = [
  {
    idi: 5,
    title: "General Setting",
    img: AppImages.profileSettings,
    nav: "GeneralsettingsOne",
  },
  {
    idi: 8,
    title: "Transportation Setting",
    img: AppImages.profileTrans,
    nav: "TransSetting",
  },
  {
    idi: 6,
    title: "Dispatch Setting",
    img: AppImages.profileDispa,
    nav: "Dispatchsettings",
  },
  {
    idi: 7,
    title: "Add-on Setting",
    img: AppImages.profileAddon,
    nav: "AddonDrawer",
  },
];

export const AdminData = [
  {
    id: 1,
    img1: AppImages.Boycircle,
    img2: AppImages.Threedots,
    H1: "Name",
    H2: "Mr John Doe",
    H3: "Email",
    H4: "Jhondoe@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
  },
  {
    id: 2,
    img1: AppImages.Cameraman,
    img2: AppImages.Threedots,
    H1: "Name",
    H2: "Mr John Doe",
    H3: "Email",
    H4: "Jhondoe@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
  },
];
export const AdminView = [
  {
    id: 1,
    H1: "Name",
    H2: "Mark Woods",
    H3: "Email",
    H4: "markwoods@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
    H7: "Vehicle Assignements",
    H8: "MH 12 AS 7807, Toyota Innova",
    Img1: AppImages.Warning,
  },
];
export const AdminView456 = [
  {
    id: 1,
    H1: "Name",
    H2: "Mark Woods",
    H3: "Email",
    H4: "markwoods@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
    H7: "Vehicle Assignements",
    H8: "MH 12 AS 7807, Toyota Innova",
    Img1: AppImages.GreenTick,
  },
];
export const AdminView123 = [
  {
    id: 1,
    H1: "Name",
    H2: "Mark Woods",
    H3: "Email",
    H4: "markwoods@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
    H7: "Vehicle Assignements",
    H8: "MH 12 AS 7807, Toyota Innova",
    Img1: AppImages.GreenTick,
  },
];
export const AdminView222 = [
  {
    id: 1,
    H1: "Name",
    H2: "Mark Woods",
    H3: "Email",
    H4: "markwoods@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
    H7: "Vehicle Assignements",
    H8: "MH 12 AS 7807, Toyota Innova",
    Img1: AppImages.GreenTick,
  },
];
export const Inspection = [
  {
    id: 1,
    H1: "Vehicle Number",
    H2: "MH09AJ5022",
    H3: "Vehicle Type",
    H4: "Utility Cab",
    H5: "Vehicle Name",
    H6: "Honda",
    H7: "Last Inspection Date",
    H8: "12-09-2023,05:48PM",
  },
];
export const Inspection1 = [
  {
    id: 1,
    H1: "Inspection Date",
    H2: "02-12-2023,05:39PM",
    H3: "Requested By",
    H4: "Rohit Sharma",
    H5: "Inspected By",
    H6: "Driver-John Doe",
    H7: "Vehicle Compliance",
    H8: "Engine Fault",
  },
];
export const InspectionDetails = [
  {
    id: 1,
    H1: "Vehicle Accident",
    H2: "Yes",
    H3: "Vehicle Accessory Changed",
    H4: "Yes",
    H5: "Vehicle Fine",
    H6: "Yes,Unpaid",
    H7: "Vehicle Maintenance",
    H8: "12-09-2023,05:48PM",
    H9: "Fuel Expence",
    H10: "$500/Month",
    H11: "RC Copy",
    H12: "Yes",
    H13: "(Original)",
    H14: "Insurance Copy",
    H15: "Yes",
    H16: "Service Logs",
    H17: "Yes",
    H18: "Tyre Life",
    H19: "Checked and Ok",
    H20: "Odometer",
    H21: "76,500Kms",
  },
];
export const DeliveryView = [
  {
    id: 1,
    H1: "Name",
    H2: "Mark Woods",
    H3: "Email",
    H4: "markwoods@gmail.com",
    H5: "Contact Number",
    H6: "9999999999",
    H7: "Vehicle Assignements",
    H8: "MH 12 AS 7807, Toyota Innova",
    Img1: AppImages.Greentick,
  },
];
export const DeliveryView1 = [
  {
    id: 1,
    H1: "Adress",
    H2: "100,Vishrantwadi,Kalas.Pune 411105",
    H3: "City",
    H4: "Pune",
    H5: "Nationality",
    H6: "India",
    H7: "Date Of Birth",
    H8: "17-08-1989",
    H9: "Joining date",
    H10: "17-08-2022",
    H11: "Gender",
    H12: "Male",
    H15: "Status",
    H16: "Active",
  },
];
export const AdminView1 = [
  {
    id: 1,
    H1: "Adress",
    H2: "100,Vishrantwadi,Kalas.Pune 411105",
    H3: "City",
    H4: "Pune",
    H5: "Nationality",
    H6: "India",
    H7: "Experience (Years)",
    H8: "4.5 Years",
    H9: "Total Distance Travelled",
    H10: "5000 Km",
    H11: "Joining date",
    H12: "17-08-2022",
    H13: "Date Of Birth",
    H14: "17-08-1989",
    H15: "Gender",
    H16: "Male",
    H17: "Status",
    H18: "Active",
    H19: "12345",
  },
];
export const AdminView21 = [
  {
    id: 1,
    H1: "Address",
    H2: "100, Vishrantwadi, Kalas , Pune 411005",
    H3: "City",
    H4: "Pune",
    H5: "Nationality",
    H6: "India",
    H7: "Date Of Birth",
    H8: "17-08-1989",
    H9: "Joining date",
    H10: "17-08-2022",
    H11: "Gender",
    H12: "Male",
    H13: "Internal Number",
    H14: "123456",
    H15: "Status",
    H16: "Active",
  },
];
export const AdminView2 = [
  {
    id: 1,
    H1: "License Information",
    H2: "ABCD123456",
    H3: "License Issue Date",
    H4: "05-05-2022",
    H5: "License Expiry Date",
    H6: "04-05-2042",
    H7: "License Type",
    H8: "Heavy Combination",
    H9: "License Area",
    H10: "Pune",
  },
];
export const Hardware = [
  {
    id: 1,
    img: AppImages.CarLock,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.CarBlock,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.CarLock,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.CarBlock,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.CarLock,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const FuelEmpty = [
  {
    id: 1,
    img: AppImages.FuelSensor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.FuelEmpty,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.FuelSensor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.FuelEmpty,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.FuelSensor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonTemperature = [
  {
    id: 1,
    img: AppImages.TemperatureSenor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonTemperature,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.TemperatureSenor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonTemperature,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.TemperatureSenor,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonIButton = [
  {
    id: 1,
    img: AppImages.IButton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonIButton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.IButton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonIButton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.IButton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonEcho = [
  {
    id: 1,
    img: AppImages.EcoDriver,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonEcho,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.EcoDriver,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonEcho,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.EcoDriver,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const Holiday = [
  {
    id: 1,
    Day: "01",
    Month: "Jan",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
    img: AppImages.Threedots,
  },
  {
    id: 2,
    Day: "01",
    Month: "Mar",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
  },
  {
    id: 3,
    Day: "01",
    Month: "Sept",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
  },
  {
    id: 4,
    Day: "01",
    Month: "Jan",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
  },
  {
    id: 5,
    Day: "01",
    Month: "Jan",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
  },
  {
    id: 6,
    Day: "01",
    Month: "Jan",
    NewYear: "New Year",
    Friday: "Friday",
    Active: "Active",
  },
];
export const Inslight = [
  {
    id: 1,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Driver Rohit Sharma ",
    H2: "added ",
    H3: "30",
    H4: " new ",
    H5: "driver’s",
  },
  {
    id: 2,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: " made a transaction of",
    H3: " $300",
    H4: " to",
    H5: " parking station",
  },
  {
    id: 3,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: " made a transaction of",
    H3: " $300",
    H4: " to",
    H5: " parking station",
  },
  {
    id: 4,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: " made a transaction of",
    H3: " $300",
    H4: " to",
    H5: " parking station",
  },
  {
    id: 5,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: " made a transaction of",
    H3: " $300",
    H4: " to",
    H5: " parking station",
  },
  {
    id: 6,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: " made a transaction of",
    H3: " $300",
    H4: " to",
    H5: " parking station",
  },
];

export const LastLogin = [
  {
    id: 1,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Driver Rohit Sharma",
    H2: " logged In from WEB.",
  },
  {
    id: 2,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: "Logged In from Mobile.",
  },
  {
    id: 3,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Administrator David Miller ",
    H2: " Logged In from Mobile.",
  },
  {
    id: 4,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Vehicle Assistant MS Dhoni ",
    H2: " Logged In from Mobile.",
  },
  {
    id: 5,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    H1: "Fleet Manager John Doe",
    H2: "Logged In from Mobile.",
  },
  {
    id: 6,
    Data: "01-01-2023,",
    Time: " 03:15 PM",

    H1: "Fleet Manager John Doe",
    H2: "Logged In from Mobile.",
  },
];

export const LastLoginView = [
  {
    id: 1,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    Name: "Fleet Manager- Jhon Doe",
    Alert: " Sleep Tracking",
    Location: " Vishrantwadi, Pune",
  },
  {
    id: 2,
    Data: "01-01-2023,",
    Time: " 03:15 PM",

    Name: "Driver- K Gowtham",
    Alert: "Accident",
    Location: " Vishrantwadi, Pune",
  },
  {
    id: 3,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    Name: "T Manager- Kyle Richie",
    Alert: "Rash Driving",
    Location: " Vishrantwadi, Pune",
  },
  {
    id: 4,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    Name: "Vehicle Assistant- jhon Doe",
    Alert: "Over Speeding",
    Location: " Vishrantwadi, Pune",
  },
  {
    id: 5,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    Name: "Driver- Rohit Sharma",
    Alert: "Late Pickup",
    Location: " Vishrantwadi, Pune",
  },
  {
    id: 6,
    Data: "01-01-2023,",
    Time: " 03:15 PM",
    Name: "Driver- Rohit Sharma",
    Alert: "Late Pickup",
    Location: " Vishrantwadi, Pune",
  },
];
export const NonSeatBelt = [
  {
    id: 1,
    img: AppImages.SeatBelt,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonSeatBelt,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.SeatBelt,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonSeatBelt,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.SeatBelt,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];

export const NonIVMS = [
  {
    id: 1,
    img: AppImages.IVMS,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonIVMS,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.IVMS,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonIVMS,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.IVMS,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];

export const NonReader = [
  {
    id: 1,
    img: AppImages.CardReader,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonReader,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.CardReader,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonReader,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.CardReader,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonOverSpeed = [
  {
    id: 1,
    img: AppImages.OverSpeed,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonOverSpeed,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.OverSpeed,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonOverSpeed,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.OverSpeed,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];

export const NonCrash = [
  {
    id: 1,
    img: AppImages.CrashDetecton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonCrash,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.CrashDetecton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonCrash,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.CrashDetecton,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonExcessive = [
  {
    id: 1,
    img: AppImages.ExcessiveIdling,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonExessive,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.ExcessiveIdling,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonExessive,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.ExcessiveIdling,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonTowing = [
  {
    id: 1,
    img: AppImages.TowingDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonTowing,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.TowingDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonTowing,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.TowingDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];
export const NonPlug = [
  {
    id: 1,
    img: AppImages.UnplugDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 2,
    img: AppImages.NonPlug,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.UnplugDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.NonPlug,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.UnplugDetection,
    H1: "Volvo Transport",
    H2: "MH-12-5022",
    H3: "Mr. John Doe",
    H4: "1234567894561230",
    H5: "Pick-Up Truck",
    H6: "Goods",
    H7: "1 Ton",
    H8: <SwitchOne />,
  },
];

export const ReAct = [
  {
    id: 1,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "In Progress",
  },
  {
    id: 2,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "In Progress",
  },
  {
    id: 3,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "In Progress",
  },
  {
    id: 4,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "In Progress",
  },
  {
    id: 5,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "In Progress",
  },
];
export const ReAct1 = [
  {
    id: 1,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Trip Type",
    H11: "120 Kms",
    Img1: AppImages.pinkone,
    Img2: AppImages.blueone,
    Img3: AppImages.redone,
    Img4: AppImages.yellowone,
    Img5: AppImages.greenone,
    Img6: AppImages.nothingone,
    Img7: AppImages.orangeone,
    Img8: AppImages.aquaone,

    H12: "Sunday",
  },
  {
    id: 2,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Trip Type",
    H11: "120 Kms",
    Img1: AppImages.pinkone,
    Img2: AppImages.blueone,
    Img3: AppImages.redone,
    Img4: AppImages.yellowone,
    Img5: AppImages.greenone,
    Img6: AppImages.nothingone,
    Img7: AppImages.orangeone,
    Img8: AppImages.aquaone,
    H12: "Not Available",
  },
  {
    id: 3,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Trip Type",
    H11: "120 Kms",
    Img1: AppImages.pinkone,
    Img2: AppImages.blueone,
    Img3: AppImages.redone,
    Img4: AppImages.yellowone,
    Img5: AppImages.greenone,
    Img6: AppImages.nothingone,
    Img7: AppImages.orangeone,
    Img8: AppImages.aquaone,
    H12: "Not Available",
  },
  {
    id: 4,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Trip Type",
    H11: "120 Kms",
    Img1: AppImages.pinkone,
    Img2: AppImages.blueone,
    Img3: AppImages.redone,
    Img4: AppImages.yellowone,
    Img5: AppImages.greenone,
    Img6: AppImages.nothingone,
    Img7: AppImages.orangeone,
    Img8: AppImages.aquaone,
    H12: "Not Available",
  },
  {
    id: 5,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Vishrantwadi,Kalas Road,Pune",
    H9: "Total Distance",
    H10: "Trip Type",
    H11: "120 Kms",
    Img1: AppImages.pinkone,
    Img2: AppImages.blueone,
    Img3: AppImages.redone,
    Img4: AppImages.yellowone,
    Img5: AppImages.greenone,
    Img6: AppImages.nothingone,
    Img7: AppImages.orangeone,
    Img8: AppImages.aquaone,
    H12: "Not Trip Assign",
  },
];
export const ReAct2 = [
  {
    id: 1,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Ch, Shivaji MaharajTerminal, Mumbai",

    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "Completed",
  },
  {
    id: 2,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Ch, Shivaji MaharajTerminal, Mumbai",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "Completed",
  },
  {
    id: 3,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Ch, Shivaji MaharajTerminal, Mumbai",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "Completed",
  },
  {
    id: 4,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Ch, Shivaji MaharajTerminal, Mumbai",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "Completed",
  },
  {
    id: 5,
    H1: "Car Type",
    H2: "Date & Time",
    H3: "Car",
    H4: "6-01-2022,1:20:00 pm",
    H5: "From",
    H6: "To",
    H7: "Vishrantwadi,SB Road,Pune",
    H8: "Ch, Shivaji MaharajTerminal, Mumbai",
    H9: "Total Distance",
    H10: "Status",
    H11: "120 Kms",
    H12: "Completed",
  },
];
export const Toycar = [
  { id: 1, image: AppImages.LuxuryBikes },
  { id: 2, image: AppImages.LuxuryCar },
  { id: 3, image: AppImages.yellowcar },
  { id: 4, image: AppImages.Bike },
  { id: 5, image: AppImages.greencar },
  { id: 6, image: AppImages.greencar },
  { id: 7, image: AppImages.yellowcar },
  { id: 8, image: AppImages.LuxuryBikes },
  { id: 9, image: AppImages.LuxuryCar },
  { id: 10, image: AppImages.greencar },
  { id: 11, image: AppImages.greencar },
  { id: 12, image: AppImages.yellowcar },
  { id: 13, image: AppImages.LuxuryBikes },
  { id: 14, image: AppImages.LuxuryCar },
  { id: 15, image: AppImages.LuxuryBikes },
];
export const Toya = [
  { id: 1, image: AppImages.LuxuryBikes },
  { id: 2, image: AppImages.LuxuryCar },
  { id: 3, image: AppImages.yellowcar },
  { id: 4, image: AppImages.Bike },
  { id: 5, image: AppImages.greencar },
];
export const BatteryStatus = [
  {
    id: 1,

    HealthStatus: "Vehicle Health Status",
    Battery: "Device Battery",
    status: "50%",
    img3: AppImages.BatteryLife,
  },
  {
    id: 2,

    HealthStatus: "Vehicle Health Status",
    Battery: "Device Battery Status",
    status: "OK",
    img3: AppImages.BatteryStatus,
  },
  {
    id: 3,

    HealthStatus: "Vehicle Health Status",
    Battery: "Vehicle Battery Voltage",
    status: "12Volts",
    img3: AppImages.BatteryVoltage,
  },
  {
    id: 4,

    HealthStatus: "Vehicle Health Status",
    Battery: "Pending Messages",
    status: "10",
    img3: AppImages.HealthMsg,
  },
  {
    id: 5,

    HealthStatus: "Vehicle Health Status",
    Battery: "Panic Alarm",
    status: "Normal",
    img3: AppImages.Panic,
  },
  {
    id: 6,

    HealthStatus: "Vehicle Health Status",
    Battery: "Running Status",
    status: "Running",
    img3: AppImages.Running,
  },
];

export const MainPOint = [
  {
    id: 1,

    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 2,

    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 3,

    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 4,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 5,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 6,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
  {
    id: 7,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Latitude: "18.5726054 ",
    Longitude: "78.8782079",
  },
];
export const StationTop = [
  {
    id: 1,

    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 2,

    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 3,

    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 4,

    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 5,

    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 6,
    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
  {
    id: 7,
    RedbytesParking: "Redbytes Parking",
    Test12345: "Test12345",
    status: "Status",
    ParkingCapacity: "10/10",
  },
];
export const GeoArea = [
  {
    id: 1,

    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 2,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 3,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 4,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 5,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 6,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
  {
    id: 7,
    Plc: "Pune",
    Test12345: "Vishrantwadi, Pune",
    Citys: "Pune",
    Country: "India",
  },
];

export const CarSug = [
  {
    id: 1,

    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 2,

    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 3,

    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 4,
    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 5,
    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 6,
    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
  {
    id: 7,
    Name: "Mr. John Doe",
    PickupTruck: "Pickup-Truck",
    Assign: "Assign",
  },
];
export const AssignedDriver = [
  {
    id: 1,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 2,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 3,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 4,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 5,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 6,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
  {
    id: 7,
    H1: "Assigned Employee",
    Dot: AppImages.Threedots,
    Dp: AppImages.DiverDp,
    DriverName: "Jhon Doe",
    ContactNumber: "Contact Number",
    Number: "+91 99223 34455",
  },
];
export const AssignedTrip = [
  {
    id: 1,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 2,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 3,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 4,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 5,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 6,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
  {
    id: 7,
    H1: "Assigned Trip Details",
    Dot: AppImages.Threedots,
    TripName: "Trip Name",
    TripType: "Trip Type",
    BusinessTrip: "Business Trip",
    PickUp: "Pick Up",
  },
];
export const GPRS = [
  {
    id: 1,
    H1: "APN Name",
    Dot: AppImages.Threedots,
    Track: "Vehicle Tracking System",
    GPRSID: "GPRS ID",
    vehicle: "vehicle@xyz.com",
    Password: "Password",
    vehicl123: "vehicle@123",
  },
];
export const DataFeq = [
  {
    id: 1,
    H1: "Vehicle Running on Home Network",
    H2: "Vehicle Running on Roaming Network",
    H3: "Vehicle Parked on Home Network",
    H4: "Vehicle Parked on Roaming Network",
    V1: "0.5s",
    V2: "0.5s",
    V3: "50s",
    V4: "1.05s",
  },
  {
    id: 2,
    H1: "Vehicle Running on Home Network",
    H2: "Vehicle Running on Roaming Network",
    H3: "Vehicle Parked on Home Network",
    H4: "Vehicle Parked on Roaming Network",
    V1: "0.5s",
    V2: "0.5s",
    V3: "50s",
    V4: "1.05s",
  },
  {
    id: 3,
    H1: "Vehicle Running on Home Network",
    H2: "Vehicle Running on Roaming Network",
    H3: "Vehicle Parked on Home Network",
    H4: "Vehicle Parked on Roaming Network",
    V1: "0.5s",
    V2: "0.5s",
    V3: "50s",
    V4: "1.05s",
  },
];
export const Alert = [
  {
    id: 1,
    H1: "Sleep Tracking",
    H2: "22-02-2022",
    H3: " 05:04:58 PM",
    H4: "Vishrantwadi, Pune",
    H5: "19.18348864  N   77.0708995  E",
  },
  {
    id: 2,
    H1: "Sleep Tracking",
    H2: "22-02-2022",
    H3: " 05:04:58 PM",
    H4: "Vishrantwadi, Pune",
    H5: "19.18348864  N   77.0708995  E",
  },
  {
    id: 3,
    H1: "Sleep Tracking",
    H2: "22-02-2022",
    H3: " 05:04:58 PM",

    H4: "Vishrantwadi, Pune",
    H5: "19.18348864  N   77.0708995  E",
  },
];

export const ToycarOne = [
  {
    id: 1,

    img: AppImages.BackgroundCarRed,
    img2: AppImages.BackGroundSkyCar,
    img3: AppImages.BackGroundYellowCar,
    img4: AppImages.BackgroundCarRed,
    img5: AppImages.BackgroundGreenCar,
  },
];
export const VehicleSelector = [
  {
    id: 1,
    H1: "Vehicle",
  },
  {
    id: 2,
    H1: "Vehicle Category",
  },
  {
    id: 3,
    H1: "Vehicle Group",
  },
  {
    id: 4,
    H1: "Sync",
  },
];
export const VehicleList = [
  {
    id: 1,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 2,
    img: AppImages.Bike,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 3,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 4,
    img: AppImages.Bike,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 5,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
];
export const VehicleSync = [
  {
    id: 1,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    Date: "12-02-2023",
    EndDate: "18-02-2023",
    Time: "04:04:53 AM",
    Range: "Date Range",
    Pendings: "Pending",
    T2: "Utility CAB",
  },
  {
    id: 2,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    Date: "12-02-2023",
    EndDate: "18-02-2023",
    Time: "04:04:53 AM",
    Range: "Date Range",
    Pendings: "Pending",
    T2: "Utility CAB",
  },
  {
    id: 3,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    Date: "12-02-2023",
    EndDate: "18-02-2023",
    Time: "04:04:53 AM",
    Range: "Date Range",
    Pendings: "Pending",
    T2: "Utility CAB",
  },
  {
    id: 4,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    Date: "12-02-2023",
    EndDate: "18-02-2023",
    Time: "04:04:53 AM",
    Range: "Date Range",
    Pendings: "Pending",
    T2: "Utility CAB",
  },
  {
    id: 5,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    Date: "12-02-2023",
    EndDate: "18-02-2023",
    Time: "04:04:53 AM",
    Range: "Date Range",
    Pendings: "Pending",
    T2: "Utility CAB",
  },
];
export const Invoice = [
  {
    To: "To",
    HD: "Payment Receipt",
    H2: "Payment Invoice",
    H3: "Invoice",
    XY: " XYZ123456",
    Name: "Mr. John Doe",
    Address: "445 5th Avenue, New York, NY, USA",
    Mob: "+91 999 999 9999",
    Email: "john@gmail.com",
    Gst: "GST / VAT",
    Num: "1",
    Service: "Service",
    Content: "10",
    Rate: "$100",
    Amt: "$1000",
    GstValue: "18%",
    Tax: "$1800",
    Igst: "₹ 0.0",
    cgst: "9%",
    Total: "$180",
    Des: "Enter Description on the Payment Receipt here...",
    Date: " 29/09/2022",
    EndDates: "09/10/2022",
    Cont: "8956142364",
  },
];

export const InvoiceRec = [
  {
    To: "To",
    HD: "Payment Invoice",
    H2: "Payment Invoice",
    H3: "Invoice",
    XY: " XYZ123456",
    Name: "Mr. John Doe",
    Address: "445 5th Avenue, New York, NY, USA",
    Mob: "+91 999 999 9999",
    Email: "john@gmail.com",
    Gst: "GST / VAT",
    Num: "1",
    Service: "Service",
    Content: "10",
    Rate: "$100",
    Amt: "$1000",
    GstValue: "18%",
    Tax: "$1800",
    Igst: "₹ 0.0",
    cgst: "9%",
    Total: "$180",
    Des: "Enter Description on the Payment Receipt here...",
    Date: " 29/09/2022",
    EndDates: "09/10/2022",
    Cont: "8956142364",
  },
];
export const PaidLIst = [
  {
    id: 1,
    img: AppImages.PaidList,
    Dot: AppImages.Threedots,
    Date: "2023",
    Services: "Services",
    Cash: "Cash / Online",
    668: "668",
    $1200: "$1200",
    T2: "20-01-2023",
  },
  {
    id: 2,
    img: AppImages.PaidList,
    Dot: AppImages.Threedots,
    Date: "2023",
    Services: "Services",
    Cash: "Cash / Online",
    668: "668",
    $1200: "$1200",
    T2: "20-01-2023",
  },
  {
    id: 3,
    img: AppImages.PaidList,
    Dot: AppImages.Threedots,
    Date: "2023",
    Services: "Services",
    Cash: "Cash / Online",
    668: "668",
    $1200: "$1200",
    T2: "20-01-2023",
  },
  {
    id: 4,
    img: AppImages.PaidList,
    Dot: AppImages.Threedots,
    Date: "2023",
    Services: "Services",
    Cash: "Cash / Online",
    668: "668",
    $1200: "$1200",
    T2: "20-01-2023",
  },
  {
    id: 5,
    img: AppImages.PaidList,
    Dot: AppImages.Threedots,
    Date: "2023",
    Services: "Services",
    Cash: "Cash / Online",
    668: "668",
    $1200: "$1200",
    T2: "20-01-2023",
  },
];
export const Hardw = [
  {
    id: 1,
    img: AppImages.CarLock,
    Switch: <SwitchOne />,
    text: "Immobilizer",
  },
  {
    id: 2,
    img: AppImages.FuelSensor,
    text: "Fuel sensor",
    Switch: <SwitchOne />,
  },
  {
    id: 3,
    img: AppImages.IButton,
    text: "I button",
    Switch: <SwitchOne />,
  },
  {
    id: 4,
    img: AppImages.EcoDriver,
    text: "Echo Driving",
    Switch: <SwitchOne />,
  },
  {
    id: 5,
    img: AppImages.SeatBelt,
    text: "Seat Belt sensor",
    Switch: <SwitchOne />,
  },
  {
    id: 6,
    img: AppImages.IVMS,
    text: "IVMS",
    Switch: <SwitchOne />,
  },
  {
    id: 7,
    img: AppImages.CardReader,
    text: "Card reader",
    Switch: <SwitchOne />,
  },
  {
    id: 8,
    img: AppImages.OverSpeed,
    text: "Over Speeding",
    Switch: <SwitchOne />,
  },
  {
    id: 9,
    img: AppImages.CrashDetecton,
    text: "Crash Detection",
    Switch: <SwitchOne />,
  },
  {
    id: 10,
    img: AppImages.ExcessiveIdling,
    text: "Excessive Idling",
    Switch: <SwitchOne />,
  },
  {
    id: 11,
    img: AppImages.TowingDetection,
    text: "Towing detection",
    Switch: <SwitchOne />,
  },
  {
    id: 12,
    img: AppImages.TemperatureSenor,
    text: "Temperature Sensors",
    Switch: <SwitchOne />,
  },
  {
    id: 13,
    img: AppImages.UnplugDetection,
    text: "un plug detection",
    Switch: <SwitchOne />,
  },
];
export const VehicleGroupR = [
  {
    id: 1,
    img: AppImages.GrpImg,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Ambani",
    H1: "Mr. John Doe",
    H2: "Drivers",
    H3: "60",
    H5: "Passenger & Goods",
    H6: "Driver Name",
    H7: "20-12-2022",
    H8: "Vehicle Type",
    H9: "5",
    // H10: 'Vehicle Capacity/Passenger',
    // H11: '60',
  },
  {
    id: 2,
    img: AppImages.GrpImg,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Ambani",
    H1: "Mr. John Doe",
    H2: "Drivers",
    H3: "60",
    H5: "Passenger & Goods",
    H6: "Driver Name",
    H7: "20-12-2022",
    H8: "Vehicle Type",
    H9: "5",
  },
  {
    id: 3,
    img: AppImages.GrpImg,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Ambani",
    H1: "Mr. John Doe",
    H2: "Drivers",
    H3: "60",
    H5: "Passenger & Goods",
    H6: "Driver Name",
    H7: "20-12-2022",
    H8: "Vehicle Type",
    H9: "5",
  },
  {
    id: 4,
    img: AppImages.GrpImg,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Ambani",
    H1: "Mr. John Doe",
    H2: "Drivers",
    H3: "60",
    H5: "Passenger & Goods",
    H6: "Driver Name",
    H7: "20-12-2022",
    H8: "Vehicle Type",
    H9: "5",
  },
  {
    id: 5,
    img: AppImages.GrpImg,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Ambani",
    H1: "Mr. John Doe",
    H2: "Drivers",
    H3: "60",
    H5: "Passenger & Goods",
    H6: "Driver Name",
    H7: "20-12-2022",
    H8: "Vehicle Type",
    H9: "5",
  },
];
export const PaymentBill = [
  {
    id: 1,
    img: AppImages.PayInvoice,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "2023",
    H1: "20-01-2023",
    H2: "Drivers",
    H3: "02-02-2023",
    H5: "$5000",
    img2: AppImages.InvoicePaper,
  },
  {
    id: 2,
    img: AppImages.PayInvoice,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "2023",
    H1: "20-01-2023",
    H2: "Drivers",
    H3: "02-02-2023",
    H5: "$5000",
    img2: AppImages.InvoicePaper,
  },
  {
    id: 3,
    img: AppImages.PayInvoice,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "2023",
    H1: "20-01-2023",
    H2: "Drivers",
    H3: "02-02-2023",
    H5: "$5000",
    img2: AppImages.InvoicePaper,
  },
  {
    id: 4,
    img: AppImages.PayInvoice,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "2023",
    H1: "20-01-2023",
    H2: "Drivers",
    H3: "02-02-2023",
    H5: "$5000",
    img2: AppImages.InvoicePaper,
  },
  {
    id: 5,
    img: AppImages.PayInvoice,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "2023",
    H1: "20-01-2023",
    H2: "Drivers",
    H3: "02-02-2023",
    H5: "$5000",
    img2: AppImages.InvoicePaper,
  },
];
export const AudioPlay = [
  {
    id: 1,
    img: AppImages.AudioMenu,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Title of Audio",
    H1: "20-01-2023",
    img2: AppImages.AudioPlay,
  },
  {
    id: 2,
    img: AppImages.AudioMenu,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Title of Audio",
    H1: "20-01-2023",
    img2: AppImages.AudioPlay,
  },
  {
    id: 3,
    img: AppImages.AudioMenu,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Title of Audio",
    H1: "20-01-2023",
    img2: AppImages.AudioPlay,
  },
  {
    id: 4,
    img: AppImages.AudioMenu,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Title of Audio",
    H1: "20-01-2023",
    img2: AppImages.AudioPlay,
  },
  {
    id: 5,
    img: AppImages.AudioMenu,
    Dot: AppImages.Threedots,
    T1: "Group  Name",
    T2: "Title of Audio",
    H1: "20-01-2023",
    img2: AppImages.AudioPlay,
  },
];
export const EmailCom = [
  {
    id: 1,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 2,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 3,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 4,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 5,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 6,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 7,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 8,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },

  {
    id: 9,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
  {
    id: 10,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
    Subject: "Subject ",
  },
];
export const VacationData = [
  {
    id: 1,

    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 2,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 3,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 4,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 5,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 6,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 7,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 8,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 9,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
  {
    id: 10,
    Name: "Vacation",
    Trip: "Wedding",
    carname: "Sisters Wedding",
    Driver: "01-01-2023",
    Subject: "01-01-2023 ",
    Status: "Inactive",
  },
];
export const EmailDetails = [
  {
    id: 1,

    Trip: "Picnic",
    vechicle: "100",
    Driver: "Jhon Doe",
    Messge:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). ",
  },
];
export const PushNotificationR = [
  {
    id: 1,

    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 2,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 3,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 4,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 5,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 6,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 7,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 8,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 9,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 10,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
  {
    id: 11,
    Name: "Mr. Jhon Doe",
    Trip: "Picnic",
    carname: "Toyota Innova",
    Driver: "Jhon Doe",
  },
];
export const AllCategory = [
  {
    id: 1,
    img: AppImages.LuxuryCar,
    Sixteen: AppImages.Sixteen,
    Name: "Luxury Car",
    Km: "2.5K",
    Count: "60",
    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
    Navi: "VehicleCategoryDetail",
  },
  {
    id: 2,
    Count: "60",
    img: AppImages.LuxuryBikes,
    Sixteen: AppImages.Sixteen,
    Name: "Bike",
    Km: "2.5K",

    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
  },
  {
    id: 3,
    Count: "60",
    img: AppImages.LuxuryCar,
    Sixteen: AppImages.Sixteen,
    Name: "Luxury Car",
    Km: "2.5K",

    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
  },
  {
    id: 4,
    Count: "60",
    img: AppImages.LuxuryBikes,
    Sixteen: AppImages.Sixteen,
    Name: "Bike",
    Km: "2.5K",

    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
  },
  {
    id: 5,
    Count: "60",
    img: AppImages.LuxuryCar,
    Sixteen: AppImages.Sixteen,
    Name: "Luxury Car",
    Km: "2.5K",

    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
  },
  {
    id: 6,
    Count: "60",
    img: AppImages.LuxuryBikes,
    Sixteen: AppImages.Sixteen,
    Name: "Bike",
    Km: "2.5K",

    Repair: "2.5K",
    Fuel: "25$/ltr",
    Seating: "5",
    Des: "This is a small vehicle with capacity of 3 passengers at a time, 300 ltr boot-space",
  },
];
export const OfflinVehicle = [
  {
    id: 1,
    img: AppImages.ShadowCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 2,
    img: AppImages.ShadowBike,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 3,
    img: AppImages.ShadowCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 4,
    img: AppImages.ShadowBike,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 5,
    img: AppImages.ShadowCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
];
export const UntrackVehicle = [
  {
    id: 1,
    img: AppImages.UntrackedCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 2,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 3,
    img: AppImages.UntrackedCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 4,
    img: AppImages.Car,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
  {
    id: 5,
    img: AppImages.UntrackedCar,
    Dot: AppImages.Threedots,
    T1: "Vehicle Name",
    T2: "Utility CAB",

    H1: "MH-12-5022",
    H2: "IMEI No.",
    H3: "1234567894561230",
    H4: "Transportation Type",
    H5: "Passenger",
    H6: "Driver Name",
    H7: "Mr. John Doe",
    H8: "Vehicle Type",
    H9: "Car",
    H10: "Vehicle Capacity/Passenger",
    H11: "60",
  },
];
// export const Transportdata = [
//   {
//     id: 1,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 2,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 3,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 4,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 5,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 6,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 7,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 8,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
//   {
//     id: 9,
//     img1: AppImages.Boypicture,
//     H1: "Name",
//     H2: "Mr.John Doe",
//     img2: AppImages.Threedots,
//     H3: "Email",
//     H4: "Contact Number",
//     H5: "Johndoe@gmail.com",
//     H6: "9999999999",
//   },
// ];
export const VehicleAssistantsdata = [
  {
    id: 1,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 2,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 3,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 4,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 5,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 6,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 7,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 8,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
  {
    id: 9,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
    H7: "Vehicle Assignments",
    H8: "Toyota Innova, Honda City",
  },
];
export const VehicleAssistantsdata1 = [
  {
    id: 1,
    img1: AppImages.Boypicture,
    H1: "Drivers Name",
    H2: "Mr.John Doe",

    H3: "Contact Number",
    H4: "Email",
    H5: "9999999999",
    H6: "Johndoe@gmail.com",
    H9: "Vehicle No",
    H10: "Vehicle Type",
    H11: "MH-12-2023",
    H12: "Toyota Innova",
    H7: "Address",
    H8: "Vishrantwadi, Kalas Road, Pune- 411030.",
  },
];
export const DispatchTrip = [
  {
    id: 1,
    img1: AppImages.Danger,
    H1: "Vehicle error description goes here... ",
    H2: "31-01-2023, 04:05:59 PM",
  },
  {
    id: 2,
    img1: AppImages.Danger,
    H1: "Vehicle error description goes here... ",
    H2: "31-01-2023, 04:05:59 PM",
  },
  {
    id: 3,
    img1: AppImages.Danger,
    H1: "Vehicle error description goes here... ",
    H2: "31-01-2023, 04:05:59 PM",
  },
  {
    id: 4,
    img1: AppImages.Danger,
    H1: "Vehicle error description goes here... ",
    H2: "31-01-2023, 04:05:59 PM",
  },
];
export const DispatchTrip1 = [
  {
    id: 1,

    H1: "Event",
    H2: "Value",

    H3: "Alert-1",
    H4: "1",
  },
  {
    id: 2,

    H1: "Event",

    H2: "Value",
    H3: "Alert-2",
    H4: "10",
  },
  {
    id: 3,

    H1: "Event",

    H2: "Value",
    H3: "Alert-3",
    H4: "1",
  },
];

export const StopName = [
  {
    id: 1,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.Ellipse6,
    H1: "Stop Name",
    H2: "Pune pmc",

    H3: "Utility Cab",
    H4: "Pick-Up Trip",

    H5: "05:30:00 AM",
    H6: "10:30:00 PM",

    H7: "Mr. John Doe",
    H8: "Mr. John Doe",
    img1: AppImages.Threedots,
  },
];
export const ButtonData10 = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "Submit" },
];
export const ButtonDataSend = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "Send" },
];
export const ButtonData11 = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "yes" },
];

export const ButtonData1 = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "Update" },
];
export const ButtonData111 = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "Continue" },
];
export const ButtonData110 = [
  { id: 1, label: "Back" },
  { id: 2, label: "Continue" },
];
export const ButtonData115 = [
  { id: 1, label: "Back" },
  { id: 2, label: "Submit" },
];
export const ButtonData105 = [
  { id: 1, label: "Cancel" },
  { id: 2, label: "Save" },
];
export const Driver1 = [
  {
    id: 1,
    img1: AppImages.Boypicture,
    H1: "Driver Name",
    H2: "Mark S Woods",
    img2: AppImages.Threedots,
    H3: "Contact No",
    H4: "9999999999",
    H5: "Email",
    H6: "markwoods@gmail.com",
    H7: "Vehicle No.",
    H8: "MH-12-2023",
    H9: "Vehicle Assignment.",
    H10: "Toyota Innova",
    H11: "Address",
    H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
  },
  {
    id: 2,
    img1: AppImages.Boypicture,
    H1: "Driver Name",
    H2: "Mark S Woods",
    img2: AppImages.Threedots,
    H3: "Contact No",
    H4: "9999999999",
    H5: "Email",
    H6: "markwoods@gmail.com",
    H7: "Vehicle No.",
    H8: "MH-12-2023",
    H9: "Vehicle Assignment.",
    H10: "Toyota Innova",
    H11: "Address",
    H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
    img3: AppImages.Greyclose,
  },
  {
    id: 3,
    img1: AppImages.Boypicture,
    H1: "Driver Name",
    H2: "Mark S Woods",
    img2: AppImages.Threedots,
    H3: "Contact No",
    H4: "9999999999",
    H5: "Email",
    H6: "markwoods@gmail.com",
    H7: "Vehicle No.",
    H8: "MH-12-2023",
    H9: "Vehicle Assignment.",
    H10: "Toyota Innova",
    H11: "Address",
    H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
    img3: AppImages.Greyclose,
  },
  {
    id: 4,
    img1: AppImages.Boypicture,
    H1: "Driver Name",
    H2: "Mark S Woods",
    img2: AppImages.Threedots,
    H3: "Contact No",
    H4: "9999999999",
    H5: "Email",
    H6: "markwoods@gmail.com",
    H7: "Vehicle No.",
    H8: "MH-12-2023",
    H9: "Vehicle Assignment.",
    H10: "Toyota Innova",
    H11: "Address",
    H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
  },
  {
    id: 5,
    img1: AppImages.Boypicture,
    H1: "Driver Name",
    H2: "Mark S Woods",
    img2: AppImages.Threedots,
    H3: "Contact No",
    H4: "9999999999",
    H5: "Email",
    H6: "markwoods@gmail.com",
    H7: "Vehicle No.",
    H8: "MH-12-2023",
    H9: "Vehicle Assignment.",
    H10: "Toyota Innova",
    H11: "Address",
    H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
  },
];

export const AddVehicleData = [
  {
    id: 1,
    section: "temperature ",
    img: AppImages.RedAcross,
    H1: "Sensor Name",
    Placeholder: "Enter Sensor Name...",
  },
  {
    id: 2,
    H1: "Minimum Temperature Threshold on Vehicle Running",
    Placeholder: "Enter Minimum Temperature Threshold on Vehicle Running...",
  },
  {
    id: 3,
    H1: "Maximum Temperature Threshold on Vehicle Running",
    Placeholder: "Enter Maximum Temperature Threshold on Vehicle Running...",
  },
  {
    id: 4,
    H1: "Minimum Temperature Threshold on Vehicle Parked",
    Placeholder: "Enter Minimum Temperature Threshold on Vehicle Parked...",
  },
  {
    id: 5,
    H1: "Minimum Temperature Threshold on Vehicle Parked",
    Placeholder: "Enter Minimum Temperature Threshold on Vehicle Parked...",
  },
  {
    id: 6,
    H1: "Minimum Temperature Threshold on Vehicle Parked",
    Placeholder: "Enter Minimum Temperature Threshold on Vehicle Parked...",
  },
];
export const CheckBoxData1 = [
  { id: 1, label: "Existing", value: "Existing" },
  { id: 2, label: "New", value: "New" },
];
export const CheckBoxData2 = [
  { id: 1, label: "Goods", value: "Goods" },
  { id: 2, label: "Passenger", value: "Passenger" },
];
export const CheckBoxData10 = [
  { id: 1, label: "Automatic", value: "Automatic" },
  { id: 2, label: "Manual", value: "Manual" },
];
export const CheckBoxData3 = [
  { id: 1, label: "Data", value: "Data" },
  { id: 2, label: "Milage", value: "Milage" },
];
export const CheckBoxData4 = [
  { id: 1, label: "Yes", value: "Yes" },
  { id: 2, label: "No", value: "No" },
];
export const CheckBoxData14 = [
  { id: 1, label: "Male", value: "Male" },
  { id: 2, label: "Female", value: "Female" },
  { id: 3, label: "Others", value: "Others" },
];
export const ButtonData = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Next", value: "Passenger" },
];

export const ButtonDataBack = [
  { id: 1, label: "Back", value: "Good" },
  { id: 2, label: "Next", value: "Passenger" },
];
export const ButtonDataSubmit = [
  { id: 1, label: "Back", value: "Good" },
  { id: 2, label: "Submit", value: "Passenger" },
];
export const ButtonDataCate = [
  { id: 1, label: "Edit", value: "Good" },
  { id: 2, label: "Delete", value: "Passenger" },
];
export const ButtonDataCR = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Update", value: "Passenger" },
];
export const ButtonCategory = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Submit", value: "Passenger" },
];
export const ButtonEditCategory = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Update", value: "Passenger" },
];

export const ButtonAddvehicle = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Apply", value: "Passenger" },
];

export const Transportdata = [
  {
    id: 1,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 2,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 3,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 4,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 5,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 6,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 7,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 8,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
  {
    id: 9,
    img1: AppImages.Boypicture,
    H1: "Name",
    H2: "Mr.John Doe",
    img2: AppImages.Threedots,
    H3: "Email",
    H4: "Contact Number",
    H5: "Johndoe@gmail.com",
    H6: "9999999999",
  },
];
export const MultiItems = [
  {
    id: "1",
    item: "Ambani (10)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
  {
    id: "2",
    item: "Adani (10)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
  {
    id: "3",
    item: "Wipro (20)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
  {
    id: "4",
    item: "Cloudxperte (10)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
  {
    id: "5",
    item: "Nasa (10)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
  {
    id: "6",
    item: "Tesla (10)",
    img: AppImages.BrownTick,
    img: AppImages.BrownTick,
    selected: false,
  },
];
export const Temperature = [{}];

export const Block = [
  { id: "1", label: "Cancel" },

  { id: "2", label: "Yes" },
];

export const ModalDel = [
  { id: 1, label: "Cancel", value: "Good" },
  { id: 2, label: "Delete", value: "Passenger" },
];
export const ModaDel = [
  { id: 1, label: "Yes", value: "Good" },
  { id: 2, label: "No", value: "Passenger" },
];
export const MasterDatatwo = [
  {
    id: 1,
    title: "Vehicles",
    img: AppImages.carVechicle,
    nav: "Vehicle",
  },
  {
    id: 2,
    title: "Vacation",
    img: AppImages.vaccation,
    nav: "Vacation",
  },
  {
    id: 3,
    title: "Point Of Interest",
    img: AppImages.pointInt,
    nav: "MainPointofInterest",
  },
];

export const MasterDataone = [
  {
    id: 1,
    title: "Holiday",
    img: AppImages.Holiday,
    nav: "Holidays",
  },
  {
    id: 2,
    title: "Parking Station",
    img: AppImages.parking,
    nav: "ParkStation",
  },
  {
    id: 3,
    title: "Geofence Area",
    img: AppImages.geofence,
    nav: "GeofenceArea",
  },
];

export const Usersone = [
  {
    id: 1,
    title: "Administrator",
    img: AppImages.admini,
    nav: "UsersAdministartion",
  },
  {
    id: 2,
    title: "Drivers",
    img: AppImages.darkDriver,
    nav: "Drivers",
  },
  {
    id: 3,
    title: "Fleet Management",
    img: AppImages.fleetcar,
    nav: "FleetManager",
  },
  {
    id: 4,
    title: "User Insights",
    img: AppImages.BottomUserInsightInActive,
    nav: "UserInsightDaily",
  },
];

export const Userstwo = [
  {
    id: 1,
    title: "Transport Manager",
    img: AppImages.transMan,
    nav: "TransportManager",
  },
  {
    id: 2,
    title: "Delivery Person",
    img: AppImages.deliMan,
    nav: "Delivery",
  },
  {
    id: 3,
    title: "Vehicle Assistants",
    img: AppImages.assist,
    nav: "VehicleAssistant",
  },
];

export const Triptwo = [
  {
    id: 1,
    title: "Trips",
    img: AppImages.trip,
    nav: "Punetrip",
  },
  {
    id: 2,
    title: "Replay",
    img: AppImages.replay,
    nav: "Playback",
  },
];
export const OperOne = [
  {
    id: 1,
    title: "Fuel Management",
    img: AppImages.accountFuel,
    nav: "TabFuel",
  },
];
export const Opertwo = [
  {
    id: 1,
    title: "Parking Management",
    img: AppImages.accountPark,
    nav: "MainParkingManagement",
  },
];
export const Triptone = [
  {
    id: 1,
    title: "Stops",
    img: AppImages.stop,
    nav: "Stop1",
  },
];
export const VechicleOne = [
  {
    id: 1,
    title: "Vehicle Accident",
    img: AppImages.backVechicle,
    nav: "VehicleExpenseOp",
  },
  {
    id: 2,
    title: "Vehicle Spare Parts",
    img: AppImages.sparePart,
    nav: "VehicleSpare",
  },
  {
    id: 3,
    title: "Fleet Maintenance",
    img: AppImages.fleetMain,
    nav: "FleetMainTab",
  },
];

export const VechicleTwo = [
  {
    id: 1,
    title: "Vehicle Accessories",
    img: AppImages.vechicleAcc,
    nav: "VehicleAccessory",
  },
  {
    id: 2,
    title: "Vehicle Fine",
    img: AppImages.fineVechcle,
    nav: "VehicleFine1",
  },
  {
    id: 3,
    title: "Fuel Expenses",
    img: AppImages.fuelEx,
    nav: "FuelExpenses",
  },
];

export const Disone = [
  {
    id: 1,
    title: "Dispatch Customers",
    img: AppImages.customerDis,
    nav: "DispatchCustomer",
  },
  {
    id: 2,
    title: "Dispatch Dashboard",
    img: AppImages.customerDis,
    nav: "DispatchDashboard",
  },
];
export const Dash = [];
export const Distwo = [
  {
    id: 1,
    title: "Orders",
    img: AppImages.orderDis,
    nav: "Orders",
  },
  {
    id: 2,
    title: "Merchant",
    img: AppImages.orderDis,
    nav: "Merchant",
  },
];
export const Insone = [
  {
    id: 1,
    title: "Dashboard",
    img: AppImages.dashImg,
    nav: "VehicleInspectionDashboard",
  },
];
export const Instwo = [
  {
    id: 1,
    title: "Inspection",
    img: AppImages.orderDis,
    nav: "VehicleInspAdd",
  },
];
export const payone = [
  {
    id: 1,
    title: "Invoice",
    img: AppImages.invoice,
    nav: "PaymentInvoice",
  },
];
export const paytwo = [
  {
    id: 1,
    title: "Paid",
    img: AppImages.paid,
    nav: "PaidInvoice",
  },
];

export const commuone = [
  {
    id: 1,
    title: "Announcement",
    img: AppImages.announce,
    nav: "Announcement",
  },
  {
    id: 2,
    title: "Push Notification",
    img: AppImages.commuNoti,
    nav: "PushNotification",
  },
];
export const commutwo = [
  {
    id: 1,
    title: "My Messages",
    img: AppImages.accountmsg,
    nav: "Allmsg",
  },
  {
    id: 2,
    title: "Email",
    img: AppImages.email,
    nav: "EmailCommunocation",
  },
];

export const Accountone = [
  {
    id: 1,
    title: "My profile",
    img: AppImages.accountPic,
    nav: "MyProfileView",
  },

  {
    id: 2,
    title: "My Language",
    img: AppImages.language,
    nav: "Languge",
  },
];
export const Accountwo = [
  {
    id: 1,
    title: "Customer Support",
    img: AppImages.supportCus,
    nav: "CusSup",
  },
  {
    id: 2,
    title: "Distribution Contact",
    img: AppImages.accountCon,
    nav: "ReportDistribution",
  },
];

export const DefaultRepo = [
  {
    id: 1,
    title: "Vehicle Running Report",
    No: "20",
    img: AppImages.defvech1,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
  {
    id: 2,
    title: "Vehicle Report",
    No: "20",
    img: AppImages.defVech2,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
  {
    id: 3,
    title: "Trip Reports",
    No: "20",
    img: AppImages.defVech3,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
  {
    id: 4,
    title: "Tracking Report",
    No: "20",
    img: AppImages.defVech4,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
  {
    id: 5,
    title: "Driver & Users Report",
    No: "20",
    img: AppImages.defVech5,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
  {
    id: 6,
    title: "Maintenance Report",
    No: "20",
    img: AppImages.defVech6,
    date: "02-01-2023",
    nav: "CompanyProfile",
  },
];
export const ViewReport = [
  {
    id: 1,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
  {
    id: 2,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
  {
    id: 3,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
  {
    id: 4,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
  {
    id: 5,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
  {
    id: 6,
    trip: "Picnic",
    vech: "Toyota Innova",
    sub: "Subject here...",
    driver: "Jhon Doe",
    nav: "CompanyProfile",
  },
];

//     H7: "Price",
//     H8: "2500",
//     H9: "Purchase From",
//     H10: "Genuine accessories, Tilak Road Pune.",
//     H11: "Date",
//     H12: "08-12-2022",
//     T3: "Expiry Date",
//     T4: "08-12-2024",
//   },
// ];
export const VehicleFine10 = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Reason",
    H4: "Status",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const VehicleFine14 = [
  {
    id: 1,
    H1: "Vehicle Name",
    H2: "Toyota Innova",
    H3: "Reason",
    H4: "Signal Break",
    H5: "Status",
    H6: "Bad",
    T1: "Amount",
    T2: "500",

    H7: "Date",
    H8: "08-12-2022",
  },
];
export const VehicleFleetM10 = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Code",
    H2: "Toyoto Innova",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Code",
    H2: "Toyoto Innova",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Code",
    H2: "Honda",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Code",
    H2: "Toyoto Innova",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Code",
    H2: "Toyoto Innova",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Code",
    H2: "Toyoto Innova",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "16-02-2023",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const FleetDetails = [
  {
    id: 1,
    H1: "Vehicle Code",
    H2: "Toyota Innova",
    H3: "Maintenance task",
    H4: "Seat Cover",
    H5: "Scheduled Duration (H)",
    H6: "16",
    T1: "Start Date",
    T2: "08-12-2024",

    H7: "Next Due Date/Milage",
    H8: "08-12-2022",
    H9: "Fleet Maintaence Next Due Date",
    H10: "08-12-2024",
    H11: "Off Road",
    H12: "yes",
  },
];
export const FuelExpense = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name & Number",
    H2: "Toyoto Innova, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Name & Number",
    H2: "Toyoto Innova, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Name & Number",
    H2: "Honda, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Name & Number",
    H2: "Toyoto Innova, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Name & Number",
    H2: "Toyoto Innova, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Name & Number",
    H2: "Toyoto Innova, MH12 SV1111",
    H3: "Current Odometer",
    H4: "Quality",
    H5: "60",
    H6: "14",
    H7: "Amount",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const FuelDetails = [
  {
    id: 1,
    H1: "Vehicle Name & Number",
    H2: "Toyota Innova,MH12 SV 1111",
    H3: "Current Odometer",
    H4: "60",
    H5: "Quantity",
    H6: "4",
    T1: "Amount",
    T2: "420",

    H7: "Date",
    H8: "08-12-2022",
  },
];
export const VehicleAccident = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Name",
    H2: "Honda Bike",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Trip Name",
    H4: "Location",
    H5: "Picnic",
    H6: "Pune",
    H7: "Expenses",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const VehicleIncident = [
  {
    id: 1,
    H1: "Vehicle Name",
    H2: "Toyota Innova",
    H3: "Location",
    H4: "Pune",
    H5: "Expenses",
    H6: "4500",
    H7: "Driver",
    H8: "Mark Woods",
    H9: "Description",
    H10: "Mirror Broke, Headlight Damage",
    H11: "Date",
    H12: "08-12-2022",
  },
];
export const VehicleAccessory12 = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Accessory Item",
    H4: "Quantity",
    H5: "Mirrors",
    H6: "2",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const VehicleAccessory14 = [
  {
    id: 1,
    H1: "Vehicle Name",
    H2: "Toyota Innova",
    H3: "Accessory Name",
    H4: "Seat Cover",
    H5: "Quantity",
    H6: "4",
    H7: "Price",
    H8: "2500",
    H9: "Purchase From",
    H10: "Genuine accessories, Tilak Road Pune.",
    H11: "Date",
    H12: "08-12-2022",
  },
];
export const Vehicleparts = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.bluecar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.Bike,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.blackcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.redcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Toyoto Innova",
    H3: "Spare Part",
    H4: "Warranty",
    H5: "Mirrors",
    H6: "2 Years",
    H7: "Price",
    H8: "Date",
    H9: "Rs 5000",
    H10: "18-02-2023",
    Dot: AppImages.Threedots,
  },
];
export const Vehiclepartss = [
  {
    id: 1,
    img: AppImages.yellowcar,
    H1: "Vehicle Name",
    H2: "Volvo Transport",
    H3: "Vehicle Number",
    H4: "Registation Number",
    H5: "MH-12-5022",
    H6: "78945612312345",
    H7: "IMEI No",
    H8: "Vehicle Type",
    H9: "12345678987451",
    H10: "Pick-Up_Truck",
    H11: "Transportation Type",
    H12: "Vehicle Capacity / Load",
    H13: "Goods",
    H14: "1 Ton",
  },
];
export const VehicleSpare14 = [
  {
    id: 1,
    H1: "Vehicle Name",
    H2: "Toyota Innova",
    H3: "Accessory Name",
    H4: "Seat Cover",
    H5: "Quantity",
    H6: "4",
    T1: "Warrenty",
    T2: "2 Years",

    H7: "Price",
    H8: "2500",
    H9: "Purchase From",
    H10: "Genuine accessories, Tilak Road Pune.",
    H11: "Date",
    H12: "08-12-2022",
    T3: "Expiry Date",
    T4: "08-12-2024",
  },
];
export const TripManagementData = [
  {
    id: 1,
    img: AppImages.defVech3,
    H1: "Trip Name",
    H2: "Pune Trip",
    H3: "Vehicle",
    H4: "Trip Category",
    H5: "Utility Cab",
    H6: "Pick -up Trip",
    H7: "Start Time",
    H8: "End Time",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
  {
    id: 2,
    img: AppImages.defVech3,
    H1: "Vehicle Code",
    H2: "Pune Trip",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
  {
    id: 3,
    img: AppImages.defVech3,
    H1: "Vehicle Code",
    H2: "Pune Trip",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
  {
    id: 4,
    img: AppImages.defVech3,
    H1: "Vehicle Code",
    H2: "Pune Trip",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
  {
    id: 5,
    img: AppImages.defVech3,
    H1: "Vehicle Code",
    H2: "Pune Trip",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
  {
    id: 6,
    img: AppImages.defVech3,
    H1: "Vehicle Code",
    H2: "Pune Trip",
    H3: "Maintenance Task",
    H4: "Scheduled Duration (H)",
    H5: "Signal Break",
    H6: "Bad",
    H7: "Start Date",
    H8: "End Date",
    H9: "05:30:00 AM",
    H10: "10:30:00 PM",
    H11: "Mr. John Doe",
    Dot: AppImages.Threedots,
  },
];
export const StepIndicData = [
  { id: 1, img: AppImages.Ellipse, H1: "Add Trip" },

  { id: 2, img: AppImages.Ellipse3, H1: "Add Stop" },
  { id: 3, img: AppImages.Ellipse4, H1: "Add Geofence" },
  { id: 4, img: AppImages.Ellipse5, H1: "View Trip" },
];
export const StepIndicData1 = [
  { id: 1, img: AppImages.Ellipse, H1: "Add Trip" },

  { id: 2, img: AppImages.Ellipse6, H1: "Add Stop" },
  { id: 3, img: AppImages.Ellipse4, H1: "Add Geofence" },
  { id: 4, img: AppImages.Ellipse5, H1: "View Trip" },
];
export const StepIndicData2 = [
  { id: 1, img: AppImages.Ellipse, H1: "Add Trip" },

  { id: 2, img: AppImages.Ellipse6, H1: "Add Stop" },
  { id: 3, img: AppImages.Ellipse7, H1: "Add Geofence" },
  { id: 4, img: AppImages.Ellipse5, H1: "View Trip" },
];
export const StepIndicData3 = [
  { id: 1, img: AppImages.Ellipse, H1: "Add Trip" },

  { id: 2, img: AppImages.Ellipse6, H1: "Add Stop" },
  { id: 3, img: AppImages.Ellipse7, H1: "Add Geofence" },
  { id: 4, img: AppImages.Ellipse8, H1: "View Trip" },
];
export const StepIndicData4 = [
  { id: 1, img: AppImages.MyLocation },
  { id: 2, img1: AppImages.LightBus },
  { id: 3, img1: AppImages.LightBus },
  { id: 4, img1: AppImages.LightBus },
  { id: 5, img: AppImages.MyLocation1 },
];
export const Trip123 = [
  {
    id: 1,
    H1: "Tip Vehicle",
    H2: "Car",
    H3: "Trip Category",
    H4: "Scheduled / Dispatch",
    H5: "Trip Type",
    H6: "Pick-up / Drop",
    H7: "Trip Start Point",
    H8: "Kolhapur, Maharashtra",
    H9: "Trip End Point",
    H10: "Pune, Maharashtra",
    H11: "Driver Name",
    H12: "Jhon Doe",
  },
];
export const Trip001 = [
  {
    id: 1,
    H1: "Tip Date",
    H2: "Trip Days",
    H3: "22-01-2023",
    H4: "Monday",
    H5: "Trip Day Start Time",
    H6: "Trip Day End Time",
    H7: "05:30:00 AM",
    H8: "05:30:00 AM",
  },
];
export const Trip0011 = [
  {
    id: 1,
    H1: "Tip Date",
    H2: "Trip Days",
    H3: "22-01-2023",
    H4: "Tuesday",
    H5: "Trip Day Start Time",
    H6: "Trip Day End Time",
    H7: "05:30:00 AM",
    H8: "05:30:00 AM",
  },
];
export const Trip201 = [
  {
    id: 1,
    H1: "Tip Date",
    H2: "Trip Days",
    H3: "22-01-2023",
    H4: "Tuesday",
    H5: "Trip Day Start Time",
    H6: "Trip Day End Time",
    H7: "05:30:00 AM",
    H8: "05:30:00 AM",
  },
];
export const Allmsgs = [
  {
    id: 1,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgBoy,
    img: AppImages.online,
  },
  {
    id: 2,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgBoy,
    img: AppImages.wait,
  },
  {
    id: 3,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgGirl,
    img: AppImages.callmsg,
  },
  {
    id: 4,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgBoy,
    img: AppImages.offline,
  },
  {
    id: 5,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgGirl,
    img: AppImages.wait,
  },
  {
    id: 6,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgGirl,
    img: AppImages.offline,
  },
  {
    id: 1,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgBoy,
    img: AppImages.callmsg,
  },
  {
    id: 7,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgGirl,
    img: AppImages.online,
  },
  {
    id: 8,
    name: "John Doe",
    num: "11/1",
    Subject: "Subject",
    profile: AppImages.msgBoy,
    img: AppImages.online,
  },
];
export const Addon = [
  {
    id: 1,
    trip: "Activate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 2,
    trip: "Deactivate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 3,
    trip: "Activate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 4,
    trip: "Deactivate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 5,
    trip: "Activate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 6,
    trip: "Deactivate ",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 7,
    trip: "Activate",
    No: "50$",
    sub: "Feburaury 20, 2023",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
];
export const Addons = [
  {
    id: 1,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 2,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month3",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 3,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 4,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 5,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 6,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
  },
  {
    id: 7,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
];
export const AddonsPre = [
  {
    id: 1,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 2,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month3",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
    image: AppImages.addon,
  },
  {
    id: 3,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 4,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
    image: AppImages.addon,
  },
  {
    id: 5,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 6,
    trip: "Add",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.white,
    bor: AppColors.brown,
    txt: AppColors.brown,
    image: AppImages.addon,
  },
  {
    id: 7,
    trip: "Buy",
    No: "Free",
    sub: "50$ / Month",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
];
export const Cart = [
  {
    id: 1,

    No: "50$",
    sub: "Free",
  },
  {
    id: 2,

    No: "50$",
    sub: "Free",
  },
  {
    id: 3,

    No: "50$",
    sub: "Free",
    box: AppColors.brown,
    bor: AppColors.brown,
    txt: AppColors.white,
  },
  {
    id: 4,

    No: "50$",
    sub: "Free",
  },
];
export const StopDetailsData = [
  {
    id: 1,
    H1: "Stop name",
    H2: "Kolhapur, Maharashtra",
    H3: "Stop Code",
    H4: "Kolhapur, Maharashtra",
    H5: "Distance from Customer",
    H6: "25 Kms",
    H7: "Stop Priority",
    H8: "2",
    H9: "Stop Latitute",
    H10: "19.25485625475158",
    H11: "Stop Longitude",
    H12: "59.25485625475158",
  },
];
export const VehiData = [
  {
    id: 1,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 2,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 3,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 4,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 5,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 6,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
  {
    id: 7,
    H1: "Vehicle",
    H2: "Toyota innova",
    img: AppImages.Threedots,
    H3: "Service Date",
    H4: "Due Date",
    H5: "10-02-2023",
    H6: "10-03-2023",
    H7: "Kilometers",
    H8: "Service Cost",
    H9: "500",
    H10: "5500",
  },
];
export const VehiMainData = [
  {
    id: 1,
    H1: "Vehicle Name",
    H2: "Toyota Innova",
    H3: "Last Service On",
    H4: "02-02-2023, 05:38PM",
    H5: "Kilometers Driven ",
    H6: "500",
    H7: "Next Service On",
    H8: "12-09-2023",
    H9: "Service Cost",
    H10: "5000 $",
    H11: "Service Type",
    H12: "Duration",
    H13: "Service Mode",
    H14: "Automatic",
  },
];
export const Inspectiontwo = [
  {
    id: 1,
    H1: "Registration Certificate",
    img1: AppImages.RegCerti,
    H2: "Insurance Copy ",
    img2: AppImages.InsureCopy,
  },
  {
    id: 2,
    H1: "Last Service Invoice",
    img1: AppImages.LastServ,
    H2: "Pollution Certificate",
    img2: AppImages.Pollution,
  },

  // {
  //   id: 3,
  //   H1: "Last Service Invoice",
  //   img1: AppImages.LastServ,
  // },
  // {
  //   id: 4,
  //   H1: "Pollution Certificate",
  //   img1: AppImages.Pollution,
  // },
];
export const Inspection24 = [
  {
    id: 1,
    H1: "Cluster Meter",
    img1: AppImages.NoImage,

    H2: "Cluster Meter",
    img2: AppImages.NoImage,
  },
  {
    id: 2,
    H1: "Cluster Meter",
    img1: AppImages.NoImage,

    H2: "Cluster Meter",
    img2: AppImages.NoImage,
  },
];
// export const TimerData = [
//   { id: 1, H1: 1 },
//   { id: 2, H2: 2 },
//   { id: 3, H3: 3 },
//   { id: 4, H4: 4 },
//   { id: 5, H5: 5 },
//   { id: 6, H6: 6 },
//   { id: 7, H7: 7 },
//   { id: 8, H8: 8 },
//   { id: 9, H9: 9 },
//   { id: 10, H10: 10 },
//   { id: 11, H11: 11 },
//   { id: 12, H12: 12 },
// ];
// export const TimerDataSec = [
//   { id: 1,H1:01 },
//   { id: 2,H1:02 },
//   { id: 3,H1:03 },
//   { id: 4,H1:04 },
//   { id: 5,H1:05 },
//   { id: 6,H1:06 },
//   { id: 7,H1:07 },
//   { id: 8,H1:08 },
//   { id: 9,H1:09 },
//   { id: 10,H1:10 },
// ];
export const Notify = [
  {
    id: 1,
    day: "Monday, 6th Apirl 2020",
    img1: AppImages.notiMSG,
    msg: "Book for General Service",
    tym: "14:07-21/11/2021",
  },
  {
    id: 2,
    day: "Monday, 6th Apirl 2020",
    img1: AppImages.notiAlert,
    msg: "Vehicle LV 001 has been marked for recall.",
    tym: "14:07-21/11/2021",
  },
  {
    id: 3,
    day: "Monday, 6th Apirl 2020",
    img1: AppImages.notiMain,
    msg: "Maintenance Completed, Collect",
    tym: "14:07-21/11/2021",
  },
];
